export default __webpack_public_path__ + "static/media/gallery_02.4831fc9a.jpg";